// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__4BcJO","title":"Loading_title__R-6aM","img":"Loading_img__W9q9B"};